import { Entity, Field } from 'typegraph';

import File from './File';

@Entity({one: "image", many: "images"})
export default class Image {
	@Field()
	public altText: string;

	@Field({entity: File})
	public file: File;
}



// WEBPACK FOOTER //
// ./src/panels/userSummary/entities/Image.ts